<template>
    <div class="shipment-page">
        <el-form :model="formData" ref="ruleForm" :rules="rules" label-position="left" label-width="80px" size="default">
            <div class="table-container">
                <!-- 标题区域 -->
                <div class="page-header">
                    <div class="header-bar"></div>
                    <div class="header-content">
                        <h2 class="header-title">编辑发货申请</h2>
                        <div class="header-sub">SHIPPING REQUEST FORM</div>
                    </div>
                    <div class="header-meta">
                        <span class="meta-label">申请日期</span>
                        <span class="meta-value">{{ formData.deliveryDate || '—' }}</span>
                    </div>
                </div>

                <table class="table-layout">
                    <tbody>
                        <!-- 第 1 行：基础信息 -->
                        <tr>
                            <td class="table-cell label-cell required">公司名称</td>
                            <td class="table-cell" colspan="3">
                                <div class="cell-input-wrap">
                                    <el-select v-if="!showInput" class="cell-control" v-model="formData.companyName" placeholder="请选择公司" size="small">
                                        <el-option
                                            v-for="item in customerList"
                                            :key="item.customerName"
                                            :label="item.customerName"
                                            :value="item.customerName">
                                        </el-option>
                                    </el-select>
                                    <input v-if="showInput" type="text" v-model="formData.companyName" class="cell-input" placeholder="请输入公司名称">
                                    <el-button size="mini" plain class="cell-toggle-btn" @click="showInput=!showInput">{{showInput?'选择':'输入'}}</el-button>
                                </div>
                            </td>
                            <td class="table-cell label-cell">业务员</td>
                            <td class="table-cell" colspan="3">
                                <input type="text" v-model="formData.salesMan" class="cell-input" placeholder="请输入业务员">
                            </td>
                        </tr>

                        <!-- 第 2 行：申请信息 -->
                        <tr>
                            <td class="table-cell label-cell required">申请原因</td>
                            <td class="table-cell" colspan="3">
                                <input type="text" v-model="formData.applyCause" class="cell-input" placeholder="请输入申请原因">
                            </td>
                            <td class="table-cell label-cell required">使用设备及描述</td>
                            <td class="table-cell" colspan="3">
                                <input type="text" v-model="formData.useDevice" class="cell-input" placeholder="请输入使用设备及描述">
                            </td>
                        </tr>

                        <!-- 申请内容标题 -->
                        <tr class="section-row">
                            <td class="section-title" colspan="8">
                                <i class="el-icon-document section-icon"></i>
                                <span>申请内容</span>
                                <span class="section-tip">（运营商 / 卡类型 / 数量等明细，可添加多行）</span>
                            </td>
                        </tr>

                        <!-- 申请内容表头 -->
                        <tr class="content-head">
                            <td class="th-cell">运营商</td>
                            <td class="th-cell">卡类型</td>
                            <td class="th-cell" colspan="2">套餐内容(注明配套餐出货或用户充值)/地区</td>
                            <td class="th-cell">数量(PCS)</td>
                            <td class="th-cell">单价(元)</td>
                            <td class="th-cell">总金额(元)</td>
                            <td class="th-cell">操作</td>
                        </tr>

                        <!-- 申请内容行 -->
                        <tr v-for="(content, index) in formData.contentList" :key="index" class="content-row">
                            <td class="td-cell">
                                <div class="cell-radio-grid">
                                    <el-radio v-model="content.operatorName" label="0">中国移动</el-radio>
                                    <el-radio v-model="content.operatorName" label="1">中国联通</el-radio>
                                    <el-radio v-model="content.operatorName" label="2">中国电信</el-radio>
                                    <el-radio v-model="content.operatorName" label="3">国际</el-radio>
                                </div>
                            </td>
                            <td class="td-cell">
                                <div class="cell-checkbox-grid">
                                    <el-checkbox v-model="content.cardList" label="插拔卡三切"></el-checkbox>
                                    <el-checkbox v-model="content.cardList" label="贴片卡5*6"></el-checkbox>
                                    <el-checkbox v-model="content.cardList" label="贴片卡2*2"></el-checkbox>
                                    <el-checkbox v-model="content.cardList" label="定向"></el-checkbox>
                                    <el-checkbox v-model="content.cardList" label="eSIM"></el-checkbox>
                                    <el-checkbox v-model="content.cardList" label="vSIM"></el-checkbox>
                                    <el-checkbox v-model="content.cardList" label="通用"></el-checkbox>
                                </div>
                            </td>
                            <td class="td-cell" colspan="2">
                                <input type="text" v-model="content.packageContent" class="cell-input" placeholder="请输入套餐内容 / 地区">
                            </td>
                            <td class="td-cell">
                                <input type="number" v-model.number="content.quantity" class="cell-input" placeholder="0" min="0">
                            </td>
                            <td class="td-cell">
                                <input type="text" v-model="content.unitPrice" class="cell-input" placeholder="0.00">
                            </td>
                            <td class="td-cell">
                                <input type="number" v-model="content.grossAmount" class="cell-input" placeholder="0.00" min="0" step="0.01">
                            </td>
                            <td class="td-cell action-cell">
                                <div class="action-btn-group">
                                    <el-button
                                        class="icon-circle-btn icon-add"
                                        type="primary"
                                        size="mini"
                                        icon="el-icon-plus"
                                        circle
                                        @click="addRow(index)"
                                        title="在此行下方添加">
                                    </el-button>
                                    <el-button
                                        v-if="formData.contentList.length > 1"
                                        style="margin-left: 0px;"
                                        class="icon-circle-btn icon-delete"
                                        type="danger"
                                        size="mini"
                                        icon="el-icon-minus"
                                        circle
                                        @click="removeContent(index)"
                                        title="删除">
                                    </el-button>
                                </div>
                            </td>
                        </tr>

                        <!-- 运输 & 发货日期 -->
                        <tr>
                            <td class="table-cell label-cell required">运输方式</td>
                            <td class="table-cell" colspan="3">
                                <div class="cell-radio-list">
                                    <el-radio v-model="formData.modeOfTransport" label="0">自提</el-radio>
                                    <el-radio v-model="formData.modeOfTransport" label="1">送货</el-radio>
                                    <el-radio v-model="formData.modeOfTransport" label="2">快递寄付</el-radio>
                                    <el-radio v-model="formData.modeOfTransport" label="3">快递到付</el-radio>
                                </div>
                            </td>
                            <td class="table-cell label-cell required">要求发货日期</td>
                            <td class="table-cell" colspan="3">
                                <el-date-picker
                                    class="cell-control"
                                    :picker-options="pickerOptions"
                                    v-model="formData.deliveryDate"
                                    type="date"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    size="small"
                                    placeholder="发货日期">
                                </el-date-picker>
                            </td>
                        </tr>

                        <!-- 收货地址 -->
                        <tr>
                            <td class="table-cell label-cell required">收货地址</td>
                            <td class="table-cell" colspan="7">
                                <input type="text" v-model="formData.shippingAddress" class="cell-input" placeholder="请输入完整收货地址">
                            </td>
                        </tr>

                        <!-- 收货人信息 -->
                        <tr>
                            <td class="table-cell label-cell required">收货人</td>
                            <td class="table-cell" colspan="3">
                                <input type="text" v-model="formData.consignee" class="cell-input" placeholder="请输入收货人姓名">
                            </td>
                            <td class="table-cell label-cell required">收货人电话</td>
                            <td class="table-cell" colspan="3">
                                <input type="text" v-model="formData.receivingPhone" class="cell-input" placeholder="请输入11位手机号" maxlength="11">
                            </td>
                        </tr>

                        <!-- 付款信息 -->
                        <tr>
                            <td class="table-cell label-cell">是否付款</td>
                            <td class="table-cell" colspan="3">
                                <div class="pay-block">
                                    <div class="cell-radio-list">
                                        <el-radio v-model="formData.whetherToPay" label="1">是</el-radio>
                                        <el-radio v-model="formData.whetherToPay" label="0">否</el-radio>
                                    </div>
                                    <el-date-picker
                                        class="pay-date-picker"
                                        :picker-options="pickerOptions"
                                        v-model="formData.toPayDate"
                                        type="date"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        size="small"
                                        placeholder="预计付款时间">
                                    </el-date-picker>
                                </div>
                            </td>
                            <td class="table-cell label-cell">付款方式</td>
                            <td class="table-cell" colspan="3">
                                <div class="cell-radio-list">
                                    <el-radio v-model="formData.payMode" label="0">对公转账</el-radio>
                                    <el-radio v-model="formData.payMode" label="1">微信</el-radio>
                                    <el-radio v-model="formData.payMode" label="2">支付宝</el-radio>
                                    <el-radio v-model="formData.payMode" label="3">测试</el-radio>
                                </div>
                            </td>
                        </tr>

                        <!-- 支付凭证 - 多图上传 -->
                        <tr>
                            <td class="table-cell label-cell">支付凭证 / 申请说明</td>
                            <td class="table-cell" colspan="7">
                                <div class="upload-block">
                                    <el-upload
                                        :action="url"
                                        accept=".jpg,.jpeg,.png"
                                        list-type="picture-card"
                                        :file-list="payVoucherList"
                                        :on-success="handlePayVoucherImgSuccess"
                                        :on-remove="handlePayVoucherRemove"
                                        :on-preview="handlePayVoucherPreview"
                                        :before-upload="beforeAvatarUpload"
                                        :limit="5"
                                        :on-exceed="handleExceed">
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                    <div class="upload-tip">
                                        <i class="el-icon-info"></i>
                                        支持 jpg / png 格式，单张不超过 2MB，最多上传 5 张，可点击预览大图
                                    </div>
                                </div>
                            </td>
                        </tr>

                        <!-- 备注 -->
                        <tr>
                            <td class="table-cell label-cell">备注</td>
                            <td class="table-cell" colspan="7">
                                <input type="text" v-model="formData.remark" class="cell-input" placeholder="如有其他需要说明的事项，请填写" onkeydown="if(event.keyCode==13){return false;}">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </el-form>

        <!-- 底部操作栏 -->
        <div class="footer-bar">
            <div class="footer-tip">
                <i class="el-icon-warning-outline"></i>
                请核对信息后再保存或提交
            </div>
            <div class="footer-actions">
                <el-button size="medium" type="info" @click="submitForm">保 存</el-button>
                <el-button size="medium" type="primary" @click="submitAndFlow">提 交</el-button>
            </div>
        </div>

        <!-- 图片预览 -->
        <el-dialog :visible.sync="previewVisible" append-to-body>
            <img width="100%" :src="previewImage" alt="">
        </el-dialog>
    </div>
</template>

<script>
    import { findShipmentRequestById, updateShipment, loginUserCustomerList, submitAndFlowShipment } from "@/api/api.js";
    import webSocketService from '@/utils/WebSocketService';
    export default {
        name: "shipmentRequestUpdate",
        components: {},
        props: {},
        data() {
            return {
                url: "cms/file/upload/shipmentRequest",
                showInput: false,
                previewVisible: false,
                previewImage: '',
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < (Date.now() - 24 * 60 * 60 * 1000);
                    }
                },
                customerList: [],
                payVoucherList: [],
                formData: {
                    id: undefined,
                    companyName: undefined,
                    salesMan: undefined,
                    applyCause: undefined,
                    useDevice: undefined,
                    modeOfTransport: undefined,
                    deliveryDate: undefined,
                    toPayDate: undefined,
                    shippingAddress: undefined,
                    consignee: undefined,
                    receivingPhone: undefined,
                    whetherToPay: undefined,
                    payMode: undefined,
                    payVoucher: undefined,
                    remark: undefined,
                    payVoucherList: [],
                    contentList: [{
                        id: undefined,
                        operatorName: undefined,
                        cardList: [],
                        packageContent: undefined,
                        quantity: 0,
                        units: undefined,
                        unitPrice: undefined,
                        grossAmount: undefined,
                        shipmentRequestId: undefined
                    }]
                },
                rules: {
                    companyName: [
                        {required: true, message: "公司名称不能为空", trigger: "change"},
                    ],
                    applyCause: [
                        {required: true, message: "申请原因不能为空", trigger: "blur"}
                    ],
                    useDevice: [
                        {required: true, message: "使用设备及场景描述不能为空", trigger: "blur"}
                    ],
                    shippingAddress: [
                        {required: true, message: "收货地址不能为空", trigger: "blur"}
                    ],
                    consignee: [
                        {required: true, message: "收货人不能为空", trigger: "blur"}
                    ],
                    receivingPhone: [
                        {
                            required: true,
                            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
                            message: "请输入正确的收货人电话",
                            trigger: "blur"
                        }
                    ]
                }
            }
        },
        computed: {},
        watch: {
            '$route': {
                handler: function (to, from) {
                    if (to.name == "shipmentRequestUpdate" && (this.formData.id != to.query.id)) {
                        this.getShipmentDetail();
                        this.loginUserCustomers();
                    }
                },
                deep: true,
            },
        },
        created() {},
        mounted() {
            this.getShipmentDetail();
            this.loginUserCustomers();
        },
        methods: {
            submitWebSocketMessage() {
                const message = {
                    content: "submit",
                    timestamp: Date.now(),
                };
                webSocketService.sendToTopic('/topic/shipment', message);
            },
            handleTimezoneConversion(dt) {
                let utcDate = new Date(dt.getTime() - (dt.getTimezoneOffset() * 60000));
                return utcDate;
            },
            loginUserCustomers() {
                loginUserCustomerList().then(res => {
                    if (res.data.code == 200) {
                        this.customerList = res.data.data;
                    }
                })
            },
            // 同步 payVoucherList 数组到 payVoucher 字符串（兼容后端）
            syncPayVoucher() {
                const list = this.payVoucherList || [];
                const urls = list
                    .map(item => item && (item.url || item.response && item.response.data && item.response.data.url))
                    .filter(Boolean)
                    .map(u => u.startsWith('/') ? u : ('/cms/' + u));
                this.formData.payVoucherList = urls || [];
            },
            submitForm() {
                if (!this.formData.companyName) {
                    this.$message.error("公司名称不能为空");
                    return
                }
                if (this.formData.deliveryDate && this.formData.deliveryDate instanceof Date) {
                    this.formData.deliveryDate = this.handleTimezoneConversion(this.formData.deliveryDate);
                }
                if (this.formData.toPayDate && this.formData.toPayDate instanceof Date) {
                    this.formData.toPayDate = this.handleTimezoneConversion(this.formData.toPayDate);
                }
                this.syncPayVoucher();
                this.$refs["ruleForm"].validate(valid => {
                    if (valid) {
                        updateShipment(this.formData).then(res => {
                            if (res.data.code == 200) {
                                this.$notify({
                                    title: "成功",
                                    message: "编辑发货申请成功",
                                    type: "success",
                                    duration: 1500
                                });
                                this.$store.dispatch('tagsView/delView', this.$route);
                                this.$router.push("/shipment/shipmentRequest");
                            } else {
                                this.$message.error(res.data.message);
                            }
                        })
                    }
                });
            },
            isValidMobileNumber(phoneNumber) {
                const regex = /^1[3-9]\d{9}$/;
                return regex.test(phoneNumber);
            },
            submitAndFlow() {
                if (!this.formData.companyName) {
                    this.$message.error("公司名称不能为空");
                    return
                }
                if (!this.formData.applyCause) {
                    this.$message.error("申请原因不能为空");
                    return
                }
                if (!this.formData.useDevice) {
                    this.$message.error("使用设备及场景描述不能为空");
                    return
                }
                if (!this.formData.modeOfTransport) {
                    this.$message.error("运输方式不能为空");
                    return
                }
                if (!this.formData.deliveryDate) {
                    this.$message.error("要求发货日期不能为空");
                    return
                }
                if (!this.formData.consignee) {
                    this.$message.error("收货人不能为空");
                    return
                }
                if (this.formData.modeOfTransport!='0' && this.formData.modeOfTransport!='1') {
                    if (!this.formData.shippingAddress) {
                        this.$message.error("非自提/送货，收货地址不能为空");
                        return
                    }
                    if (!this.formData.receivingPhone) {
                        this.$message.error("非自提/送货，收货人电话不能为空");
                        return
                    }
                    if (!this.isValidMobileNumber(this.formData.receivingPhone)) {
                        this.$message.error("非自提/送货，收货人电话格式不正确");
                        return
                    }
                }
                if (!this.checkPayVoucher()) {
                    this.$message.error("已付款：必须选择付款方式，上传支付凭证（非测试）；未付款：必须填写预付款时间和上传申请说明");
                    return
                }
                if (!this.formData.contentList) {
                    this.$message.error("明细不能为空");
                    return
                }
                let filteredArray = this.formData.contentList.filter(function(item) {
                    return item.operatorName !== null && item.operatorName !== undefined && item.operatorName !== ''
                        && item.packageContent !== null && item.packageContent !== undefined && item.packageContent !== ''
                        && item.cardList !== null && item.cardList.length > 0
                        && item.unitPrice !== null && item.unitPrice !== undefined
                        && item.grossAmount !== null && item.grossAmount !== undefined
                        && item.quantity !== null && item.quantity !== undefined ;
                });
                if (filteredArray.length<=0) {
                    this.$message.error("明细不能为空");
                    return
                } else {
                    this.formData.contentList = filteredArray;
                }
                if (this.formData.deliveryDate && this.formData.deliveryDate instanceof Date) {
                    this.formData.deliveryDate = this.handleTimezoneConversion(this.formData.deliveryDate);
                }
                if (this.formData.toPayDate && this.formData.toPayDate instanceof Date) {
                    this.formData.toPayDate = this.handleTimezoneConversion(this.formData.toPayDate);
                }
                this.syncPayVoucher();
                this.$refs["ruleForm"].validate((valid) => {
                    if (valid) {
                        submitAndFlowShipment(this.formData).then((res) => {
                            if (res.data.code == 200) {
                                this.$notify({
                                    title: "成功",
                                    message: "提交成功",
                                    type: "success",
                                    duration: 1500,
                                });
                                this.$store.dispatch('tagsView/delView', this.$route);
                                this.$router.push("/shipment/shipmentRequest");
                                this.submitWebSocketMessage()
                            } else {
                                this.$message.error(res.data.message);
                            }
                        });
                    }
                });
            },
            resetForm() {
                this.$refs['ruleForm'].resetFields()
            },
            addRow(afterIndex) {
                if (this.formData.contentList.length >= 20) {
                    this.$message.warning('最多可添加 20 行');
                    return;
                }
                const newItem = {
                    operatorName: '',
                    cardList: [],
                    packageContent: '',
                    quantity: 0,
                    units: "",
                    unitPrice: "",
                    grossAmount: ""
                };
                if (afterIndex === undefined) {
                    this.formData.contentList.push(newItem);
                } else {
                    this.formData.contentList.splice(afterIndex + 1, 0, newItem);
                }
            },
            removeContent(index) {
                if(this.formData.contentList.length >= 2) {
                    this.formData.contentList.splice(index, 1);
                }
            },
            checkPayVoucher() {
                if (this.formData.payMode == '3') {
                    return true;
                } else {
                    if (this.formData.whetherToPay == '0' && !this.formData.toPayDate){
                        return false;
                    }
                    const urls = this.payVoucherList
                        .filter(f => (f.response && f.response.data && f.response.data.url) || f.url);
                    if(urls.length === 0){
                        return false;
                    }
                    return true
                }
            },
            // 上传支付凭证图片
            handlePayVoucherImgSuccess(res, file) {
                if (res.code == 200) {
                    if (file && file.response) {
                        file.url = "/cms/" + res.data.url;
                        if (!this.payVoucherList) {
                            this.payVoucherList = [];
                        }
                        const existIdx = this.payVoucherList.findIndex(f => f.uid === file.uid);
                        if (existIdx > -1) {
                            this.payVoucherList[existIdx] = file;
                        } else {
                            this.payVoucherList.push(file);
                        }
                    }
                    this.$message.success('上传成功');
                } else {
                    this.$message.error(res.message || '上传失败');
                    const list = this.payVoucherList || [];
                    const idx = list.findIndex(f => f.uid === file.uid);
                    if (idx > -1) list.splice(idx, 1);
                }
            },
            handlePayVoucherRemove(file, fileList) {
                this.payVoucherList = fileList;
            },
            handlePayVoucherPreview(file) {
                this.previewImage = file.url;
                this.previewVisible = true;
            },
            handleExceed() {
                this.$message.warning('最多只能上传 5 张图片');
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                }
                const isJpgOrPng = /\.(jpe?g|png)$/i.test(file.name);
                if (!isJpgOrPng) {
                    this.$message.error('只支持 jpg / png 格式');
                }
                return isLt2M && isJpgOrPng;
            },
            // 查询发货申请详情
            getShipmentDetail() {
                let id = this.$route.query && this.$route.query.id;
                findShipmentRequestById({id: id}).then(res => {
                    this.formData = { ...this.formData, ...res.data.data };
                    this.formData.contentList.forEach(m => {
                        m.cardType = undefined
                    });
                    // 将后端 图片 字符串转换为文件列表
                    if(res.data.data.payVoucherList && res.data.data.payVoucherList.length > 0){
                        this.payVoucherList = res.data.data.payVoucherList.map(u => ({ url: u }));
                    } else {
                        this.payVoucherList = [];
                    }
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    @primary: #409EFF;
    @primary-dark: #337ECC;
    @success: #67C23A;
    @danger: #F56C6C;
    @warning: #E6A23C;
    @text-primary: #303133;
    @text-regular: #606266;
    @text-secondary: #909399;
    @text-placeholder: #C0C4CC;
    @border-base: #DCDFE6;
    @border-light: #E4E7ED;
    @bg-page: #F0F2F5;
    @bg-section: #F5F7FA;
    @bg-header: linear-gradient(135deg, #409EFF 0%, #337ECC 100%);

    .shipment-page {
        min-height: 100vh;
        background: @bg-page;
        padding: 24px 16px 100px;
        box-sizing: border-box;
    }

    /* ================= 容器 ================= */
    .table-container {
        max-width: 1200px;
        margin: 0 auto;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
        overflow: hidden;
        position: relative;
    }

    /* ================= 标题区域 ================= */
    .page-header {
        display: flex;
        align-items: center;
        padding: 20px 28px;
        background: @bg-header;
        color: #fff;
        position: relative;
    }
    .header-bar {
        width: 5px;
        height: 36px;
        background: #fff;
        border-radius: 3px;
        margin-right: 14px;
        opacity: 0.85;
    }
    .header-content {
        flex: 1;
    }
    .header-title {
        margin: 0;
        font-size: 22px;
        font-weight: 600;
        letter-spacing: 2px;
        line-height: 1.2;
    }
    .header-sub {
        margin-top: 4px;
        font-size: 12px;
        letter-spacing: 1.5px;
        opacity: 0.7;
    }
    .header-meta {
        text-align: right;
        font-size: 13px;
        .meta-label {
            display: block;
            opacity: 0.7;
            font-size: 12px;
        }
        .meta-value {
            display: block;
            font-size: 16px;
            font-weight: 500;
            margin-top: 2px;
        }
    }

    /* ================= 表格 ================= */
    .table-layout {
        table-layout: auto;
        border-collapse: collapse;
        width: 100%;
        margin: 0;

        td {
            border: 1px solid @border-light;
            padding: 10px 12px;
            text-align: left;
            vertical-align: middle;
            font-size: 14px;
            color: @text-primary;
            line-height: 1.5;
        }

        .label-cell {
            background: @bg-section;
            color: @text-regular;
            font-weight: 500;
            text-align: center;
            width: 92px;
            min-width: 92px;
            max-width: 132px;
            white-space: nowrap;
            position: relative;
            &.required::before {
                content: '*';
                color: @danger;
                margin-right: 4px;
                font-weight: 700;
            }
        }

        .section-row {
            td {
                background: #ECF5FF;
                border-color: #B3D8FF;
            }
        }
        .section-title {
            color: @primary;
            font-weight: 600;
            font-size: 14px;
            padding: 10px 16px;
            .section-icon {
                margin-right: 6px;
                font-size: 15px;
            }
            .section-tip {
                margin-left: 8px;
                font-weight: normal;
                color: @text-secondary;
                font-size: 12px;
            }
        }

        .content-head {
            .th-cell {
                background: @bg-section;
                color: @text-regular;
                font-weight: 600;
                text-align: center;
                font-size: 13px;
                padding: 8px 6px;
            }
        }
        .content-row {
            td {
                transition: background 0.2s;
            }
            &:hover td {
                background: #FAFBFC;
            }
        }
    }

    /* ================= 单元格内的输入控件 ================= */
    .cell-input-wrap {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .cell-input {
        width: 100%;
        height: 32px;
        line-height: 32px;
        padding: 0 10px;
        border: 1px solid @border-base;
        border-radius: 4px;
        background: #fff;
        font-size: 14px;
        color: @text-primary;
        box-sizing: border-box;
        transition: border-color 0.2s, box-shadow 0.2s;
        outline: none;

        &::placeholder {
            color: @text-placeholder;
            font-size: 13px;
        }
        &:hover {
            border-color: #C0C4CC;
        }
        &:focus {
            border-color: @primary;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
        }
        &[type="number"] {
            -moz-appearance: textfield;
            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }
        }
    }
    .cell-toggle-btn {
        flex-shrink: 0;
    }
    .cell-control {
        width: 100%;
        /deep/ .el-input__inner {
            height: 32px;
            line-height: 32px;
            border-color: @border-base;
        }
        /deep/ .el-input__icon {
            line-height: 32px;
        }
        /deep/ .el-tag--small {
            height: 22px;
            line-height: 20px;
        }
    }
    .cell-radio-list,
    .cell-checkbox-list {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 2px 8px;
        /deep/ .el-radio,
        /deep/ .el-checkbox {
            margin: 0;
            line-height: 20px;
        }
        /deep/ .el-radio__label,
        /deep/ .el-checkbox__label {
            font-size: 13px;
            padding-left: 4px;
        }
    }
    /* 申请内容区域：运营商 / 卡类型 双列网格，每行 2 个 */
    .cell-radio-grid,
    .cell-checkbox-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 6px 4px;
        justify-items: start;
        /deep/ .el-radio,
        /deep/ .el-checkbox {
            margin: 0;
            line-height: 20px;
        }
        /deep/ .el-radio__label,
        /deep/ .el-checkbox__label {
            font-size: 13px;
            padding-left: 4px;
        }
    }
    .action-cell {
        text-align: center;
        vertical-align: middle;
        .action-btn-group {
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 8px;
        }
    }

    /* 圆形图标按钮（+ / -） */
    .icon-circle-btn {
        width: 30px;
        height: 30px;
        padding: 0;
        font-size: 13px;
        transition: transform 0.15s, box-shadow 0.2s;
        &.is-disabled {
            opacity: 0.4;
        }
        &:not(.is-disabled):hover {
            transform: scale(1.08);
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
        }
        /deep/ i {
            font-weight: 700;
        }
    }
    .icon-add {
        background: @primary;
        border-color: @primary;
        /deep/ i {
            color: #fff;
        }
    }
    .icon-delete {
        background: @danger;
        border-color: @danger;
        /deep/ i {
            color: #fff;
        }
    }

    /* 申请内容表头单元格 */
    .th-cell, .td-cell {
        border: 1px solid @border-light;
        padding: 10px 8px;
        text-align: center;
        vertical-align: middle;
        &:nth-child(1) { min-width: 160px; }
        &:nth-child(2) { min-width: 210px; }
    }

    /* ================= 添加行 ================= */
    .add-row-cell {
        background: #FAFBFC;
        padding: 12px 16px;
        text-align: left;
    }

    /* ================= 付款块 ================= */
    .pay-block {
        display: flex;
        align-items: center;
        gap: 12px;
    }
    .pay-date-picker {
        width: 172px;
        /deep/ .el-input__inner {
            border-radius: 4px;
            border: 1px solid #DCDFE6;
            transition: border-color 0.2s, box-shadow 0.2s;
            &:hover,
            &:focus {
                border-color: #409EFF;
            }
            &:focus {
                box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
            }
        }
    }

    /* ================= 上传 ================= */
    .upload-block {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    .upload-tip {
        color: @text-secondary;
        font-size: 12px;
        line-height: 1.5;
        i {
            color: @primary;
            margin-right: 4px;
        }
    }
    /deep/ .el-upload--picture-card {
        width: 100px;
        height: 100px;
        line-height: 100px;
    }
    /deep/ .el-upload-list--picture-card .el-upload-list__item {
        width: 100px;
        height: 100px;
    }

    /* ================= 底部操作栏 ================= */
    .footer-bar {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        height: 64px;
        background: #fff;
        box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 32px;
        z-index: 100;
    }
    .footer-tip {
        position: absolute;
        left: 32px;
        color: @text-secondary;
        font-size: 13px;
        i {
            color: @warning;
            margin-right: 4px;
        }
    }
    .footer-actions {
        .el-button {
            margin-left: 12px;
            min-width: 88px;
        }
    }
</style>
